import { useState } from 'react';

const INITIAL_SEARCH_PARAMS = {
  search: '',
  page: 0,
  pageSize: 10,
};

export default function useSearchAssignableExamCourseSearchParams() {
  const [{ search, page, pageSize }, setDataGridParams] = useState(INITIAL_SEARCH_PARAMS);

  const changePageNumber = (page: number) => {
    setDataGridParams((prev) => ({ ...prev, page }));
  };

  const changePageSize = (pageSize: number) => {
    setDataGridParams((prev) => ({ ...prev, pageSize }));
  };

  const changeSearch = (searchValue: string) => {
    setDataGridParams((prev) => ({ ...prev, search: searchValue }));
  };

  return [
    { search, page, pageSize },
    { changePageNumber, changePageSize, changeSearch },
  ] as const;
}
